import type { InputHTMLAttributes, ReactNode } from 'react'

import { forwardRef } from 'react'
import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

interface CheckboxProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
    label: ReactNode
}

const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(({ className, label, id, checked, ...props }, ref) => {
    const checkboxId = id ?? props.name

    return (
        <label htmlFor={checkboxId} className='group flex cursor-pointer items-start gap-3'>
            <span className='relative mt-0.5 inline-flex h-5 w-5 shrink-0 items-center justify-center'>
                <input
                    ref={ref}
                    id={checkboxId}
                    type='checkbox'
                    checked={checked}
                    className={cn(
                        'peer h-5 w-5 cursor-pointer appearance-none rounded-[6px] border-2 border-neutral-300 bg-white',
                        'checked:border-brand-red checked:bg-brand-red',
                        'focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-brand-red/20',
                        'transition-colors',
                        className
                    )}
                    {...props}
                />

                <Check
                    aria-hidden
                    className='pointer-events-none absolute h-3.5 w-3.5 text-white opacity-0 transition-opacity peer-checked:opacity-100'
                    strokeWidth={3}
                />
            </span>

            <span className='text-sm text-neutral-700'>{label}</span>
        </label>
    )
})

Checkbox.displayName = 'Checkbox'

export default Checkbox
